import { useLanguage } from '@athena/ui'
import { useNavigate, useSearch } from '@tanstack/react-router'

import { DashboardView, type DashboardFilterValue } from '../features/dashboard/DashboardView.js'

/**
 * Reads the filter off the URL and hands it to the dashboard.
 *
 * Split for the same reason `AttemptScreen` is split from `AttemptRunner`:
 * `useSearch({ from })` needs the real route to exist, and reproducing the
 * tutor route tree in every dashboard test buys nothing. The URL is this
 * file's whole job.
 */
export function DashboardScreen() {
  const language = useLanguage()
  const navigate = useNavigate()
  const search = useSearch({ from: '/$language/tutor/' })

  return (
    <DashboardView
      filter={{
        studentId: search.studentId,
        practiceId: search.practiceId,
      }}
      onFilterChange={(next: DashboardFilterValue) => {
        void navigate({
          to: '/$language',
          params: { language },
          search: {
            ...(next.studentId ? { studentId: next.studentId } : {}),
            ...(next.practiceId ? { practiceId: next.practiceId } : {}),
          },
        })
      }}
    />
  )
}
